import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import classnames from 'classnames';

import { Image } from 'components/ui';
import { getDocumentToReactComponentsOptions } from 'helpers/LandingPageHelpers';

import type { IContentfulImage, IContentfulRichText, Nullable } from 'types';

import styles from './AlphaTemplateHighlightBlock.module.scss';

interface Props {
  type: 'genius' | 'primary',
  isMobilePreview: boolean,
  isImageOutside: boolean,
  text: Nullable<IContentfulRichText>,
  textSize: string,
  image: IContentfulImage
}

const AlphaTemplateHighlightBlock = (props: Props) => {

  const {
    type, text, textSize, image, isImageOutside,
    isMobilePreview
  } = props;

  const { json: textJson } = text || {};
  const { url, height = 1, width } = image || {};

  const options = React.useMemo(() => getDocumentToReactComponentsOptions({ isMobilePreview }), [isMobilePreview]);

  return (
    <div
      className={classnames(styles.root, styles[type])}
      style={isImageOutside ? { paddingTop: `${height / 2 + 64}px` } : {}}
    >
      <div className={styles.inner}>
        <div
          className={classnames(styles.imageContainer, { [styles.offset]: isImageOutside })}
          style={isImageOutside ? {
            height: `${height}px`,
            top: `-${height / 2 + 56}px`
          } : {}}
        >
          <div className={styles.image}>
            <Image
              optimize
              quality={100}
              src={url}
              height={height}
              width={width}
            />
          </div>
        </div>
        <div className={classnames(styles.text, styles[textSize])}>
          {documentToReactComponents(textJson, options)}
        </div>
      </div>
    </div>
  );
};

export default AlphaTemplateHighlightBlock;
